import * as React from 'react';
export var SocialIconOk = function SocialIconOk() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 20",
    width: "12",
    height: "20"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M6 3.454c1.107 0 2.006.9 2.006 2.006a2.007 2.007 0 0 1-4.011 0c0-1.107.9-2.006 2.005-2.006m0 6.85a4.848 4.848 0 0 0 4.845-4.844A4.85 4.85 0 0 0 6 .615 4.85 4.85 0 0 0 1.156 5.46 4.85 4.85 0 0 0 6 10.303m1.96 3.951a9.043 9.043 0 0 0 2.813-1.166 1.42 1.42 0 0 0-1.512-2.403 6.148 6.148 0 0 1-6.522 0 1.417 1.417 0 0 0-1.956.447c-.419.664-.22 1.54.444 1.956.875.55 1.827.942 2.812 1.166l-2.707 2.708a1.42 1.42 0 0 0 2.008 2.006l2.659-2.66 2.663 2.66a1.418 1.418 0 1 0 2.006-2.006L7.96 14.254z"
  }));
};